"use client";

import { useLocation } from "react-router-dom";

const layout = ({ children }) => {
    const { pathname } = useLocation();
    const legacyProduct = pathname.replace(/\/+$/, "") === "/recruiters/ai-interview-bot";

    return (
        <section className={`relative isolate overflow-hidden${legacyProduct ? " marketing-legacy-product pt-[120px]" : ""}`}>
            {children}
        </section>
    )
}

export default layout
